var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142,
    height: 142,
    viewBox: "0 0 202 201",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_400_30508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2937 50.6953L152.36 149.42",
    stroke: "#5B57F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.7 49.689L51.9756 151.755",
    stroke: "#5B57F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.259 99.9415L100.546 73.1357L73.7402 100.849L101.453 127.655L128.259 99.9415Z",
    stroke: "#5B57F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_30508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 142,
    fill: "white",
    transform: "translate(0.604736 102.066) rotate(-45.9535)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerStar);
export default __webpack_public_path__ + "static/media/banner-star.facd72cc9d1f3ef6fcf87ba8208b7d88.svg";
export { ForwardRef as ReactComponent };